<template>
  <div class="promo-bar" @click="$emit('open-form')">
    <img
      v-show="currentIndex === 0"
      src="@/assets/topbanner1.png"
      alt="프로모션"
      class="promo-img"
    />
    <img
      v-show="currentIndex === 1"
      src="@/assets/topbanner2.png"
      alt="프로모션"
      class="promo-img"
    />
    <div class="shine-effect"></div>
  </div>
</template>

<script>
export default {
  name: 'MobilePromoBar',
  emits: ['open-form'],
  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },
  mounted() {
    this.startBannerSwitch()
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    startBannerSwitch() {
      this.timer = setInterval(() => {
        this.currentIndex = this.currentIndex === 0 ? 1 : 0
      }, 500)
    }
  }
}
</script>

<style scoped>
.promo-bar {
  position: fixed;
  top: 65px;
  left: 0;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  z-index: 999;
}

.promo-img {
  display: block;
  width: 100%;
  height: auto;
}

/* 유리 닦는 효과 */
.shine-effect {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent 30%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 70%
  );
  animation: shine 2.5s ease-in-out infinite;
  pointer-events: none;
}

@keyframes shine {
  0% { left: -100%; }
  40%, 100% { left: 100%; }
}
</style>